<template>
    <div>
        <div class="list-products">
            <div class="card-body">
                <div
                    v-for="(product, indexProduct) in products"
                    class="row show-grid product"
                    :class="'group-' + product.name.replace(/\s+/g, '-').toLowerCase()"
                    v-if="showProduct(product)"
                >
                    <div class="col-md-12 header-product-name">
                        <div class="header-product-name-trigger " >
                            <h2 class="product-title-wrapper">
                                <img v-bind:src="'images/program-icons/' + product.title.replace(' ', '-') + '.svg'" alt="icon">
                                <span class="product-head">{{product.name}}</span>
                                <div class="product-type">{{ product.description }}</div>
                                <div class="tab-content">

                                    <div
                                    :class="'tab-pane show active panel_' + product.name.replace(/\s+/g, '-').toLowerCase() + '_lease'"
                                        :id="'panel_' + product.name.replace(/\s+/g, '-').toLowerCase() + '_lease'"
                                        role="tabpanel"
                                        aria-labelledby="second-tab"
                                    >
                                        <div class="nav-info">
                                            {{ product.description }}
                                        </div>
                                    </div>

                                </div>
                            </h2>

                            <div class="header-name-block">
                                <div class="row">
                                    <div class="col-8 col-md header-name header-name__first">
                                        {{ getTranslation('product-list-vue', 'programs_and_packages') }}
                                    </div>
                                    <div class="col-4 col-md-1 header-name col-price">
                                        {{ getTranslation('front', 'price') }}
                                    </div>
                                    <div class="col-4 col-md-2 header-name col-spinner">
                                        {{ getTranslation('product-list-vue', 'local_licences') }}
                                    </div>
                                    <template v-if="product.purchase_options.has_network">
                                        <div class="col-4 col-md-2 header-name col-spinner">
                                                {{ getTranslation('product-list-vue', 'network_licences') }}
                                        </div>
                                    </template>

                                    <div class="col-4 col-md-2 header-name col-price col-price--total">
                                        {{ getTranslation('front', 'total') }}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- end tab buttons-->

                        <div class="tab-content">

                            <div
                                class="tab-pane show active"
                                :id="'v-pills-' + product.name.replace(/\s+/g, '-').toLowerCase() + '-lease'"
                                :class="'v-pills-' + product.name.replace(/\s+/g, '-').toLowerCase()"
                                role="tabpanel"
                                :aria-labelledby="'v-pills-' + product.name.replace(/\s+/g, '-').toLowerCase() + '-lease-tab'"
                                v-if="product.purchase_options.has_lease"
                            >
                                <div class="product-subtitle">

                                </div>
                                <div
                                    :id="'collapse_' + product.name.replace(/\s+/g, '-').toLowerCase() + '_lease'"
                                    class="collapsible-panel "
                                    :class="product.name.replace(/\s+/g, '-').toLowerCase() + 'lease-perpetual-collapse'"
                                >
                                    <div class="header-name-block header-name-block__sticky">
                                        <div class="row">
                                            <div class="col-8 col-md header-name header-name__first">
                                                {{ getTranslation('product-list-vue', 'programs_and_packages') }}
                                            </div>
                                            <div
                                                class="col-4 col-md-1 header-name col-price text-center"
                                                v-html="getTranslation('product-list-vue', 'price_for_lease')"
                                            >
                                            </div>
                                            <div class="col-4 col-md-2 header-name col-spinner">
                                                {{ getTranslation('product-list-vue', 'cloud_licences') }}
                                            </div>
                                            <template v-if="product.purchase_options.has_network">
                                                <div class="col-4 col-md-2 header-name col-spinner">
                                                    {{ getTranslation('product-list-vue', 'network_licences') }}
                                                </div>
                                            </template>
                                            <template v-if="isTruss4Product(product.id)">
                                                <div class="col-4 col-md-2 header-name col-spinner text-center" style="align-items: center;justify-content: center;">
                                                    {{ getTranslation('product-list-vue', 'period') }}
                                                </div>
                                            </template>

                                            <div
                                                class="col-4 col-md-1 header-name col-price col-price--total"
                                                v-if="$store.state.cart.loggedInUser"
                                                v-html="getTranslation('product-list-vue', 'existing_licenses')"
                                            >
                                            </div>

                                            <div class="col-4 col-md-2 header-name col-price col-price--total" >
                                                {{ getTranslation('front', 'total') }}
                                            </div>
                                        </div>
                                    </div>
                                    <program-list
                                        v-bind:product="product"
                                        prefix="lease"
                                    ></program-list>
                                </div>
                            </div>

                            </div>

                        </div>
                        <!-- END .tab-content -->
                </div>

            </div>
        </div>


        <div class="form-group">
            <label for="order_note">{{ getTranslation('front', 'NOTE') }}</label>
            <textarea id="order_note" class="form-control" v-model="userNote" rows="5" cols="40"></textarea>
        </div>

        <br><br>
        <div class="order-summary__footer">
            <a @click="goToKeySetup()" id="continueNextStep"  class="btn btn-primary submitbtn btn-order ml-auto submitCart">
                <span class="continue">{{ getTranslation('front', 'continue') }}</span>
                <span class="continue-spinner align-items-center d-none">
                    <b-spinner small variant="light" label="Loading..."></b-spinner> {{ getTranslation('front', 'loading')}}
                </span>
            </a>
        </div>

        <b-modal id="bv-modal-warning" centered hide-footer>
            <template #modal-title>
                <div class="modal-title__icon">
                    <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                    </svg>
                </div>
                <span>{{ getTranslation('key-setup-vue', 'warning') }}</span>
            </template>
            <div class="d-block text-center">
                <p>{{ getTranslation('home','empty_cart_error') }}</p>
                <br><br>
            </div>
            <div class="text-center">
                <b-button class="mt-3 mx-auto"  @click="closeModal()">{{ getTranslation('front', 'close') }}</b-button>
            </div>
        </b-modal>
        <b-modal id="bv-modal-upgrade" centered hide-footer>
            <template #modal-title>
                <div class="modal-title__icon">
                    <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" ><path fill="currentColor" d="M256 40c118.621 0 216 96.075 216 216 0 119.291-96.61 216-216 216-119.244 0-216-96.562-216-216 0-119.203 96.602-216 216-216m0-32C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm-11.49 120h22.979c6.823 0 12.274 5.682 11.99 12.5l-7 168c-.268 6.428-5.556 11.5-11.99 11.5h-8.979c-6.433 0-11.722-5.073-11.99-11.5l-7-168c-.283-6.818 5.167-12.5 11.99-12.5zM256 340c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28z"></path>
                    </svg>
                </div>
            </template>
            <div class="d-block" style="padding: 0 10px">
                <div v-if="!loggedInUser" v-html="getTranslation('product-list-vue', 'message_new_customer_modal_upgrade_line_1')"></div>
                <div v-if="loggedInUser" v-html="getTranslation('product-list-vue', loggedInUpgradeMessageLine1)"></div>
                <br>
                <div class="bv-modal-lineTwo" v-html="getTranslation('product-list-vue', 'message_upgrade_to_' + upgradeUserLevel)"></div>
                <br><br>
            </div>
            <div class="text-center">
                <b-button class="mt-3 mx-auto"  @click="closeUpgradeModal()">{{ getTranslation('front', 'close') }}</b-button>
                <b-button class="mt-3 mx-auto"  @click="continueNextStep()">{{ getTranslation('front', 'modal_upgrade_continue_button') }}</b-button>
            </div>
        </b-modal>
    </div>
</template>


<script>
    export default {
        computed: {
            leaseProlongPrice() {
                let self = this;
                let total = {};
                let keys = Object.keys(this.products);

                for (const key of keys) {
                    if (_.isUndefined( total[key])) {
                        total[key] = 0;
                    }
                    if (!_.isUndefined(this.$store.state.cart.leaseProlong[key])) {
                        if (!_.isNil(this.$store.state.cart.leaseProlong[key])) {
                            if (this.$store.state.cart.leaseProlong[key].status) {
                                if (this.isTruss4Product(key)) {
                                    let info = this.$store.state.cart.leaseProlong[key].info[0];
                                    total[key] = this.getTruss4Price(info.id, '', info.licence_type, info.product, this.$store.state.cart.leaseProlong[key].info.length, true)
                                } else {
                                    _.forOwn(this.$store.state.cart.leaseProlong[key].info, function (pr, ind) {
                                        if (pr.selected) {
                                            let basePrice = self.getProgramPrice(pr.id, '', 'cloud_time_quantity', pr.product, pr.quantity);
                                            total[key] = total[key] + basePrice;
                                        }
                                    });
                                }
                            }
                        }

                    }
                }
                return total;
            },
        },
        methods: {
            showProduct(product) {
                if (this.checkCanPurchaseLeaseProlong(product.id) && this.isTruss4Product(product.id)) {
                    return false;
                }
                return true;
            },
            checkCanPurchaseLeaseProlong(id) {
                if (!_.isNil(this.$store.state.cart.leaseProlong[id])) {
                    return true;
                }
                return false;
            },
            closeModal() {
                this.$bvModal.hide('bv-modal-warning')
            },

            closeUpgradeModal() {
                this.$bvModal.hide('bv-modal-upgrade');
            },
            scrollToElement(id) {
                // document.getElementById(id).scrollIntoView({behavior: "auto", block: "start", inline: "start"});
                if ($("#" + id).length) {
                    $([document.documentElement, document.body]).animate({
                        scrollTop: $("#" + id).offset().top + 10
                    }, 100);
                }

            },
            initUserInfo() {
                if (!_.isNil(this.$store.state.cart.userInfo) && !_.isEmpty(this.$store.state.cart.userInfo)) {
                    return this.$store.state.cart.userInfo;
                }
                let payload = {note: ''};
                return payload;
            },

            getLatestVersion(productId) {
                return this.products[productId]['latestVersion'];
            },
            getLeaseDateFromString(dateString, months = 12) {
                let d = new Date(dateString);
                let newDate = new Date(d.setMonth(d.getMonth()+months));
                return ( Number(newDate.getFullYear())  ) + '-' +  ("0"+(newDate.getMonth()+1)).slice(-2) + '-' + ("0" + newDate.getDate()).slice(-2);
            },

            goToKeySetup() {
                //create existing hardlocks and licenses
                if (this.canSubmit == false) {
                    return 1;
                }
                let self = this;
                this.setSpinner();
                this.canSubmit = false;

                if (this.canContinueNextStep() == false) {
                    this.$bvModal.show('bv-modal-warning');
                    this.canSubmit = true;
                    this.resetSpinner();
                    return;
                }


                if (this.checkUserUpgraded()) {
                    this.$bvModal.show('bv-modal-upgrade');
                    this.canSubmit = true;
                    this.resetSpinner();
                    return false;
                }
                let step = 3;
                let navigation  = this.navigation.user_info;
                if (!_.isUndefined(this.navigation.licences_setup)) {
                    step = 2;
                    navigation  = this.navigation.licences_setup;
                }

                if (this.$store.state.cart.cartStep <= 2) {
                    let payload = {'step': step};
                    this.$store.commit('setCartStep', payload);
                }

                let payload = {'text': this.userNote};
                this.$store.commit('setUserNote', payload);
                window.location.href = navigation;
            },
            excludeUserUpgradeVersion(l) {
                return false;
            },
            checkUserUpgraded() {
                let self = this;
                let singleLicenses = [];
                let hasTruss4 = false;

                if (!_.isNil(this.existingLicenses)) {
                    _.forEach(this.existingLicenses, function(p, key) {
                        if (!self.isTruss4Product(p.product)) {
                            if (p.upgradeExcluded === false && p.maintenance_excluded === false) {
                                let oldVersionExclude = self.excludeUserUpgradeVersion(p);
                                if (oldVersionExclude) {
                                    return;
                                }
                                _.forEach(p['singleLicences'], function(s) {
                                    if (_.isNil(singleLicenses[s])) {
                                        singleLicenses[s] = (_.parseInt(p['cloud_time_quantity']) || 0)  +
                                            (_.parseInt(p['cloud_perpetual_quantity']) || 0) +
                                            (_.parseInt(p['local_lease_quantity']) || 0) +
                                            (_.parseInt(p['local_quantity']) || 0) +
                                            (_.parseInt(p['network_lease_quantity']) || 0) +
                                            (_.parseInt(p['network_quantity']) || 0);
                                    } else {
                                        singleLicenses[s] +=(_.parseInt(p['cloud_time_quantity']) || 0)  +
                                            (_.parseInt(p['cloud_perpetual_quantity']) || 0) +
                                            (_.parseInt(p['local_lease_quantity']) || 0) +
                                            (_.parseInt(p['local_quantity']) || 0) +
                                            (_.parseInt(p['network_lease_quantity']) || 0) +
                                            (_.parseInt(p['network_quantity']) || 0);
                                    }
                                });
                            }

                        } else {
                            if (
                                _.parseInt(p['cloud_time_quantity']) ||
                                _.parseInt(p['cloud_perpetual_quantity']) ||
                                _.parseInt(p['local_lease_quantity']) ||
                                _.parseInt(p['local_quantity']) ||
                                _.parseInt(p['network_lease_quantity']) ||
                                _.parseInt(p['network_quantity'])
                            ) {
                                hasTruss4 = true;
                            }
                        }
                    });
                }

                let maxExisting = _.max(singleLicenses) || 0;

                if (this.$store.state.cart.programs.length) {
                    _.forEach(this.$store.state.cart.programs, function(p, key) {
                        if (!self.isTruss4Product(p.product)) {
                            _.forEach(p['singleLicences'], function(s) {
                                if (_.isNil(singleLicenses[s])) {
                                    singleLicenses[s] = (_.parseInt(p['cloud_time_quantity']) || 0)  + (_.parseInt(p['cloud_perpetual_quantity']) || 0);
                                } else {
                                    singleLicenses[s] +=( _.parseInt(p['cloud_time_quantity']) || 0) + (_.parseInt(p['cloud_perpetual_quantity']) || 0);
                                }
                            });
                        } else {
                            if (_.parseInt(p['cloud_time_quantity']) || _.parseInt(p['cloud_perpetual_quantity'])) {
                                hasTruss4 = true;
                            }
                        }
                    });
                }

                let max = _.max(singleLicenses) || 0;

                if (maxExisting === max) {
                    this.loggedInUpgradeMessageLine1 = 'message_account_upgrade_because_existing_line_1';
                } else {
                    this.loggedInUpgradeMessageLine1 = 'message_account_upgrade_line_1';
                }
                let userLevel = this.$store.state.cart.userLevel;
                let userType = window.shopUserTypes.find(u => u.type === userLevel);

                this.setUserLevel(max, hasTruss4);

                if (hasTruss4 && userLevel === 'personal') {
                    return true;
                }

                if (userType['maxLicenses'] < max) {
                    return true;
                }

                this.$store.commit('changeUserLevel', this.upgradeUserLevel);
                return false;
            },
            setUserLevel(max, hasTruss4) {
                if (this.$store.state.cart.forceUserLevel === 'enterprise') {
                    this.upgradeUserLevel = this.$store.state.cart.forceUserLevel;
                    return false;
                }

                if (this.$store.state.cart.existingUserLevel === 'enterprise') {
                    this.upgradeUserLevel = this.$store.state.cart.existingUserLevel;
                    return false;
                }

                if (max > this.userTypesConfig.businessLimit) {
                    this.upgradeUserLevel = 'enterprise';
                    return false;
                }

                if (this.$store.state.cart.forceUserLevel === 'business') {
                    this.upgradeUserLevel = this.$store.state.cart.forceUserLevel;
                    return false;
                }

                if (this.$store.state.cart.existingUserLevel  === 'truss4' || this.$store.state.cart.existingUserLevel  === 'business') {
                    this.upgradeUserLevel = this.$store.state.cart.existingUserLevel;
                    return false;
                }

                if (hasTruss4) {
                    this.upgradeUserLevel = 'truss4';
                    return false;
                }
                if (max > this.userTypesConfig.personalLimit) {
                    this.upgradeUserLevel = 'business';
                    return false;
                }

                this.upgradeUserLevel = 'personal';
                return false;
            },
            continueNextStep() {
                this.$store.commit('changeUserLevel', this.upgradeUserLevel);
                this.goToKeySetup();
            },
            hasSubscriptionPromo() {
                if (_.isNil(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                if (_.isEmpty(this.$store.state.cart.subscriptionPromo)) {
                    return false;
                }
                return true;
            },
            canContinueNextStep() {
                if (this.$store.state.cart.programs.length) {
                    return true;
                }
                if (this.hasSubscriptionPromo()) {
                    return true;
                }
                if (this.userHasActiveSubscription) {
                    return true;
                }
                let self = this;
                let hasAnyPurchase = false;
                _.forOwn(this.products, function(p) {
                    if (self.leaseProlongPrice[p.id]) {
                        hasAnyPurchase = true;
                    }
                });
                if (hasAnyPurchase) {
                    return true;
                }
                return false;
            },

        },
        data() {
            return {
                products: window.jsonProducts,
                baseUrl: window.baseUrl,
                userInfo: {},
                navigation: window.quickNavigationUrls,
                canSubmit: true,
                userNote: '',
                canPurchaseMaintenance: JSON.parse(window.canPurchaseMaintenance),
                updateSingleUpgradeForMaintenance: {1: false, 2: false},
                existingHardlocks: window.existingHardlocks,
                existingLicenses: window.existingLicenses,
                upgradedPrefix: window.upgradedPrefix,
                shopUserTypes: window.shopUserTypes,
                userTypesConfig: window.userTypesConfig,
                upgradeUserLevel: '',
                existingUserTypeId: window.existingUserType,
                loggedInUser: 0,
                loggedInUpgradeMessageLine1: 'message_account_upgrade_line_1',
                versionIgnore: window.versionIgnore,
                userHasActiveSubscription: window.userHasActiveSubscription
            };
        },
        mounted() {
            this.userInfo = this.initUserInfo();
            window.productList=this;
            this.userNote = this.$store.state.cart.userNote;

            this.upgradeUserLevel = this.$store.state.userLevel;
            this.loggedInUser = loggedInUser;
        }
    }
</script>
<style>
.bv-modal-lineTwo p {
    margin-bottom: 10px;
}

</style>
